<template>
  <div class="wrap m-a" id="wrap">
    <!-- banner:start -->
    <section class="about-banner banner p-r">
      <div class="about-img"><i></i></div>
      <div class="about-banner-txt p-a c-c">
        <h3>About FJDynamics</h3>
      </div>
    </section>
    <!-- banner:end -->
    <!-- content:start -->
    <div class="content m-a">
      <div class="left-menu">
        <div class="product-bar d-n">About Us</div>
        <ul id="left-menu">
          <li>
            <i class="d-ib menu-icon arrow-icon-com va-m in-pc"></i>
            <a href="/blog">Company New</a>
            <i class="d-ib arrow-icon-arrow va-m in-pc"></i>
          </li>
          <li>
            <i class="d-ib menu-icon arrow-icon-wit va-m in-pc"></i>
            <a href="/FJD-witness">FJD Witness</a>
            <i class="d-ib arrow-icon-arrow va-m in-pc"></i>
          </li>
          <li>
            <i class="d-ib menu-icon arrow-icon-who va-m in-pc"></i>
            <a href="/webinarcenter">FJD Webinar</a>
            <i class="d-ib arrow-icon-arrow va-m in-pc"></i>
          </li>
        </ul>
      </div>
      <div class="right-content">
        <div class="intro p-r c-h ov-h">
          <!-- <div class="download p-r f-r"><a href=""></a></div> -->
          <div class="intro-txt f-l">
            <h2>Who We Are</h2>
            <p>FJDynamics is a robotics company focusing on digitization, automation and new energy.</p>
            <p>
              At present, our technology has been widely applied across agriculture, construction, geospatial, mowing,
              etc. The company has R&D and operation centers in Singapore, U.S., Sweden, mainland China and Hong Kong.
              With the global reach of our business, we are excited to work with our partners and customers to build a
              better future for our world.
            </p>
            <p>
              We are committed to making useful and affordable robots for the most labor-intensive industries, using our
              technology to drive carbon neutrality and improve the working environment.
            </p>
          </div>
        </div>
        <div class="video-1 p-r">
          <div class="v-box p-r">
            <video
              ref="video"
              id="aboutVideo"
              width="100%"
              height="auto"
              loop
              preload="none"
              controls
              src="https://1500006283.vod2.myqcloud.com/6c9ac49bvodcq1500006283/bc6cb7223701925923703696032/LkCm4SUOj7cA.mp4"
              poster="https://1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/bc6cb7223701925923703696032/snapshotByTimeOffset/snapshotByTimeOffset_10_1.jpg"
            ></video>
            <img
              v-show="!isPlayVideo"
              style="display: block; position: absolute; top: 0; left: 0; z-index: 3"
              src="//1500006283.vod2.myqcloud.com/4384b243vodtranscq1500006283/bc6cb7223701925923703696032/snapshotByTimeOffset/snapshotByTimeOffset_10_1.jpg"
              width="100%"
              height="100%"
            />
            <i class="play-icon d-ib p-a" v-show="!isPlayVideo" @click="playVideo"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        isPlayVideo: false
      }
    },
    head() {
      return {
        title: 'About FJD - FJDynamics',
        meta: [
          // hid is used as unique identifier. Do not use `vmid` for it as it will not work
          {
            name: 'keywords',
            content: 'farm machinery,RTK,precision farming,autopilot,Autosteering kit'
          },
          {
            hid: 'description',
            name: 'description',
            content:
              'FJDynamics is a global robotics company  advanced manufacturing. We aim at providing a full range of autonomous and digital solutions for the industrial automation and the intelligence of agriculture, forestry, animal husbandry, fishery and construction. '
          }
        ]
      }
    },
    created() {},
    methods: {
      playVideo() {
        this.isPlayVideo = true
        this.$refs.video.play()
      }
    }
  }
</script>

<style scoped lang="scss">
  .wrap {
    overflow: hidden;
    box-sizing: border-box;
  }
  /* banner */
  .about-img i {
    display: block;
    height: 3.6rem;
    background: url('@/assets/images/about/about_banner.jpg') no-repeat center;
    background-size: cover;
  }
  .about-banner {
    margin-top: 3.9583vw;
  }
  .about-banner-txt {
    /* width: 1000px; */
    text-align: center;
  }
  .about-banner-txt h3 {
    font-size: 0.48rem;
    // font-family: 'Alibaba Sans';
    font-weight: 700 !important;
    color: #fff;
  }
  .about-banner-txt h4 {
    font-size: 24px;
    letter-spacing: 0;
  }

  /* content */
  .content {
    display: flex;
    justify-content: center;
    margin-bottom: 0.8rem;
  }
  .left-menu {
    margin-right: 0.68rem;
    margin-top: 0.8rem;
    overflow: hidden;
  }
  .left-menu ul {
    display: block;
  }
  .left-menu li {
    cursor: pointer;
    margin-bottom: 0.28rem;
  }
  .left-menu li a {
    font-size: 0.2rem;
    color: #262626;
    vertical-align: middle;
    min-width: 1.4rem;
    // 为元素修复抖动
    &::before {
      // display: block;
      content: attr(title);
      font-weight: bold;
      height: 0;
      overflow: hidden;
      visibility: hidden;
    }
  }
  .left-menu li:hover .arrow-icon-arrow {
    transition: transform 0.3s linear;
    transform: translateX(4px);
  }

  .left-menu li:hover a {
    font-weight: 600;
    font-size: 0.2rem;
  }

  .menu-icon {
    width: 40px;
    height: 40px;
    background-color: transparent;
    /* border-radius: 50%; */
    margin-right: 16px;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-position: center center;
    box-sizing: border-box;
    background-size: cover;
  }
  .arrow-icon-arrow {
    width: 0.2rem;
    height: 0.2rem;
    margin-left: 8px;
    vertical-align: middle;
    background-image: url("data:image/svg+xml,%3Csvg width='20' height='20' viewBox='0 0 20 20' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath stroke='%23262626' stroke-width='1.2' stroke-linecap='round' stroke-linejoin='round' d='M7.5 16.667L14.167 10 7.5 3.333' fill='none' fill-rule='evenodd'/%3E%3C/svg%3E");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: 50% 50%;
    background-position: center center;
  }

  .arrow-icon-com {
    width: 0.32rem;
    height: 0.32rem;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill-opacity='.01' fill='%23FFF' fill-rule='nonzero' d='M0 0h32v32H0z'/%3E%3Cpath stroke='%23262626' stroke-width='1.778' stroke-linecap='round' d='M3.333 27.333h25.334'/%3E%3Cpath stroke='%23262626' stroke-width='1.778' stroke-linecap='round' stroke-linejoin='round' d='M6 26.667V12h12v14.667'/%3E%3Cpath d='M9.333 18h5.334m-5.334 4h5.334' stroke='%23191923' stroke-width='1.867' stroke-linecap='round'/%3E%3Cpath stroke='%23262626' stroke-width='1.778' stroke-linecap='round' stroke-linejoin='round' d='M14 11.333v-6L26.667 8v19.333'/%3E%3C/g%3E%3C/svg%3E");
  }
  .arrow-icon-wit {
    width: 0.32rem;
    height: 0.32rem;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill-opacity='.01' fill='%23FFF' fill-rule='nonzero' d='M0 0h32v32H0z'/%3E%3Cg stroke-linejoin='round' stroke='%23262626' stroke-width='1.778'%3E%3Cpath d='M3.333 7.736c0-.59.496-1.07 1.108-1.07h18.684c.612 0 1.108.48 1.108 1.07v4.813l4.434-3.209v13.855l-4.434-3.209v4.278c0 .59-.496 1.07-1.108 1.07H4.442c-.613 0-1.109-.48-1.109-1.07V7.736z'/%3E%3Cpath d='M10.667 17.333a3.333 3.333 0 1 0 0-6.666 3.333 3.333 0 0 0 0 6.666z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
  .arrow-icon-web {
    width: 0.32rem;
    height: 0.32rem;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill-opacity='.01' fill='%23FFF' fill-rule='nonzero' d='M0 0h32v32H0z'/%3E%3Cg transform='translate(7.533 15.667)' fill='%23262626' fill-rule='nonzero'%3E%3Ccircle cx='1.133' cy='1.133' r='1.133'/%3E%3Ccircle cx='6.467' cy='1.133' r='1.133'/%3E%3Ccircle cx='11.8' cy='1.133' r='1.133'/%3E%3C/g%3E%3Cpath d='M4.667 9.333h18.666c.369 0 .667.299.667.667v13.268a.667.667 0 0 1-.673.667l-6.549-.064L14 26.667l-2.778-2.796-6.549.064A.667.667 0 0 1 4 23.268V10c0-.368.298-.667.667-.667z' stroke='%23262626' stroke-width='1.778' stroke-linecap='round' stroke-linejoin='round'/%3E%3Cpath d='M14 5.333h12.667c.736 0 1.333.597 1.333 1.334v12.666' stroke='%23262626' stroke-width='1.778' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/g%3E%3C/svg%3E");
  }
  .arrow-icon-who {
    width: 0.32rem;
    height: 0.32rem;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill-opacity='.01' fill='%23FFF' fill-rule='nonzero' d='M0 0h32v32H0z'/%3E%3Cg stroke-linecap='round' stroke='%23262626' stroke-width='1.778'%3E%3Cg transform='translate(3.667 9.333)'%3E%3Ccircle stroke-linejoin='round' cx='6.667' cy='3.667' r='3.667'/%3E%3Cpath d='M0 16.667a6.667 6.667 0 1 1 13.333 0'/%3E%3C/g%3E%3Cpath stroke-linejoin='round' d='M12 6.667v-2h16.667v14.666H17.333'/%3E%3Cpath d='M24.667 9.333h-7.334M24.667 14h-6'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }
  .arrow-icon-who {
    width: 0.32rem;
    height: 0.32rem;
    background-image: url("data:image/svg+xml,%3Csvg width='32' height='32' viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cpath fill-opacity='.01' fill='%23FFF' fill-rule='nonzero' d='M0 0h32v32H0z'/%3E%3Cg stroke-linecap='round' stroke='%23262626' stroke-width='1.778'%3E%3Cg transform='translate(3.667 9.333)'%3E%3Ccircle stroke-linejoin='round' cx='6.667' cy='3.667' r='3.667'/%3E%3Cpath d='M0 16.667a6.667 6.667 0 1 1 13.333 0'/%3E%3C/g%3E%3Cpath stroke-linejoin='round' d='M12 6.667v-2h16.667v14.666H17.333'/%3E%3Cpath d='M24.667 9.333h-7.334M24.667 14h-6'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  }

  .right-content {
    border-left: 1px solid #d4d4d4;
    padding-left: 0.96rem;
    width: 11.24rem;
    margin-top: 0.8rem;
    /* margin-left: 2.08rem; */
  }
  .w1000px {
    width: 1000px;
  }
  .intro {
    width: 11.24rem;
    padding-left: 0.46rem;
    /* padding-top: 120px; */
  }
  .intro-txt {
    float: none;
    color: #000;
    /* margin-top: -50px; */
  }

  .intro-txt h2 {
    font-size: 0.34rem;
    margin-bottom: 15px;
    font-weight: 700;
  }
  .intro-txt p {
    font-size: 0.2rem;
    line-height: 1.5;
    color: #666;
  }
  .download {
    width: 200px;
    height: 250px;
    background-color: rgba(236, 236, 236, 1);
  }
  .download a {
    display: block;
    position: absolute;
    width: 30px;
    height: 30px;
    right: 15px;
    bottom: 20px;
    background: url('/images/down_ico.png');
  }
  .download a:hover {
    background-image: url('/images/down_ico_h.png');
  }
  /* .v-box {
    height: 562px;
  } */
  .v-box a i {
    position: absolute;
    z-index: 9;
    top: 0;
    left: 0;
    display: block;
    width: 100%;
    height: 100%;
    background-size: cover;
  }
  .v-box a {
    display: block;
    height: 100%;
  }
  .v-box a:hover {
    background-color: rgba(0, 0, 0, 0);
  }
  .video-1 {
    /* margin-bottom: 0.8rem; */
    width: 11.24rem;
    margin-top: 30px;
  }
  .video-1 .play-icon {
    border: none;
  }
  .milestones {
    padding-top: 80px;
    padding-bottom: 116px;
    color: #000;
  }
  .milestones h4 {
    font-size: 38px;
    margin-bottom: 90px;
  }
  .milestones dt,
  .milestones dd {
    float: left;
    color: #333;
  }
  .milestones dt {
    width: 200px;
    font-size: 50px;
    clear: left;
    margin-top: -5px;
    font-family: 'Bebas', 'Alibaba Sans', 'Open Sans', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue',
      'Hiragino Sans GB', 'WenQuanYi Micro Hei', 'Arial', 'sans-serif';
    line-height: 1;
  }
  .milestones dd {
    font-size: 22px;
    padding-left: 80px;
    padding-bottom: 100px;
    border-left: 1px solid #d8d8d8;
  }
  .milestones dd:last-child,
  .milestones dd:last-child div {
    padding-bottom: 0;
    margin: 0;
  }
  .milestones dd div {
    position: relative;
    padding-left: 100px;
    margin-bottom: 40px;
    line-height: 30px;
    overflow: hidden;
  }
  .milestones dd b {
    clear: left;
    float: left;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 30px;
    font-family: 'Bebas', 'Alibaba Sans', 'Open Sans', 'PingFang SC', 'Microsoft YaHei', 'Helvetica Neue',
      'Hiragino Sans GB', 'WenQuanYi Micro Hei', 'Arial', 'sans-serif';
  }
  .milestones dd span {
    float: left;
    width: 550px;
    line-height: 34px;
    color: rgba(102, 102, 102, 1);
  }
</style>
